<script>
    import ButtonSpinner from '@/components/shared/ButtonSpinner';
    import router from '@/router';

    export default {
        components: {
            ButtonSpinner
        },
        data() {
            return {
                errorTimer: null,
                isLoading: 0
            };
        },
        computed: {
            getYear() {
                const date = new Date();
                return date.getFullYear();
            }
        },
        methods: {
            onSubmit() {
                if (this.errorTimer !== null) return alert('Please wait before trying again.');

                this.isLoading++;
                window.location.href = `/api/auth/login?redirectHost=${window.location.origin}`;
            }
        },
        mounted() {
            const now = Date.now();
            const rejectionData = JSON.parse(localStorage.getItem('loginRejection') || 'null');

            if (router.currentRoute.value.query?.error === 'rejected' || (rejectionData && now - rejectionData.time < 30000)) {
                if (!rejectionData || now - rejectionData.time >= 30000) {
                    localStorage.setItem('loginRejection', JSON.stringify({ time: now }));
                }

                this.errorTimer = 0;
                let interval = setInterval(() => {
                    this.errorTimer++;
                    if (this.errorTimer >= 30) {
                        this.errorTimer = null;
                        clearInterval(interval);
                        localStorage.removeItem('loginRejection');
                    }
                }, 1000);
            }
        }
    };
</script>

<template>
    <div class="login">
        <!-- START card-->
        <div class="card card-flat mx-auto" style="width: 350px">
            <div class="card-header text-center bg-primary">
                <img class="block-center rounded" src="/assets/images/logo.svg" alt="Image" />
            </div>
            <div class="card-body">
                <p class="text-center py-2">WELCOME TO ADMIN PORTAL</p>
                <form class="mb-3" @submit.prevent="onSubmit">
                    <ButtonSpinner
                        v-if="errorTimer === null"
                        :isLoading="isLoading"
                        btn-class="btn btn-lg btn-primary mt-3 w-100"
                        text="Login"
                    />
                    <template v-else>
                        <div class="alert alert-danger mb-3 text-center">Session Rejected</div>
                        <button class="btn btn-lg btn-secondary mt-3 w-100" disabled>Please wait {{ 30 - errorTimer }} seconds...</button>
                    </template>
                </form>
            </div>
        </div>
        <!-- END card-->
        <div class="p-3 text-center">
            <span>&copy;</span>
            <span>{{ getYear }}</span>
            <span class="mx-1">-</span>
            <span>GreaseBook</span>
            <br />
            <small>Now, the industry's #1 oil {{ `&` }} gas production app!</small>
            <br />
        </div>
    </div>
</template>
<style lang="scss">
    .login {
        padding-top: 80px;
        height: 100vh;
    }
</style>
